import React from 'react';
import { TableRow, TableCell, Box, Chip } from '@mui/material';
import { User } from '../../../types';
import { formatDate } from '../../../utils/dateFormatter';
import { ActionButton } from './ActionButton';
import {
  ModeEdit as EditIcon,
  MoreHoriz as MoreHorizIcon,
} from '@mui/icons-material';
import type { UserTableRowProps } from '../../../types/admin';

export const UserTableRow: React.FC<UserTableRowProps> = ({
  user,
  onEdit,
  onMenuOpen,
}) => {
  const createdAtStr = formatDate(user.createdAt);
  const updatedAtStr = formatDate(user.updatedAt);
  
  return (
    <TableRow 
      sx={{ 
        '&:hover': { 
          backgroundColor: '#F5F5F5',
          '& .action-cell': {
            backgroundColor: '#F5F5F5',
          },
        }, 
        borderBottom: 'none' 
      }}
    >
      <TableCell sx={{ color: '#000000', fontSize: '14px', borderBottom: 'none', py: 1.5, pl: 4 }}>
        {user.displayName || '-'}
      </TableCell>
      <TableCell sx={{ color: '#000000', fontSize: '14px', borderBottom: 'none', py: 1.5 }}>
        {user.email}
      </TableCell>
      <TableCell sx={{ borderBottom: 'none', py: 1.5 }}>
        <Chip
          label={user.role === 'admin' ? '管理者' : '閲覧者'}
          size="small"
          sx={{
            background: user.role === 'admin' 
              ? '#1B76D2' 
              : '#F7F7F7 0% 0% no-repeat padding-box',
            borderRadius: '10px',
            color: user.role === 'admin' ? '#FFFFFF' : 'rgba(0, 0, 0, 0.6)',
            fontSize: '12px',
            fontWeight: 300,
            height: '26px',
            border: user.role === 'admin' ? 'none' : '1px solid #E0E0E0',
          }}
        />
      </TableCell>
      <TableCell sx={{ color: '#000000', fontSize: '14px', borderBottom: 'none', py: 1.5 }}>
        {createdAtStr}
      </TableCell>
      <TableCell sx={{ color: '#000000', fontSize: '14px', borderBottom: 'none', py: 1.5 }}>
        {updatedAtStr}
      </TableCell>
      <TableCell 
        align="center" 
        className="action-cell"
        sx={{ borderBottom: 'none', py: 1.5, position: 'sticky', right: 0, backgroundColor: '#FFFFFF', zIndex: 10, pr: 2 }}
      >
        <Box display="flex" gap={1} justifyContent="center" alignItems="center">
          <ActionButton
            onClick={() => onEdit(user)}
            icon={<EditIcon sx={{ fontSize: '18px' }} />}
          />
          <ActionButton
            onClick={(e) => onMenuOpen(e, user)}
            icon={<MoreHorizIcon sx={{ fontSize: '18px' }} />}
            backgroundColor="#616161"
            color="#FFFFFF"
            borderColor="#616161"
            hoverBackgroundColor="#424242"
          />
        </Box>
      </TableCell>
    </TableRow>
  );
};

